/**
 * WalletTile - Connected wallet balance tile
 */
import React from 'react';

const WalletTile = ({ balance, loading, onClick }) => (
  <button
    onClick={onClick}
    style={{
      position: 'absolute',
      width: '39px',
      height: '39px',
      borderRadius: '3px',
      background: 'linear-gradient(135deg, #9945FF 0%, #7B2CBF 30%, #5A189A 70%, #3D0E61 100%)',
      border: '0.5px solid rgba(255, 255, 255, 0.15)',
      boxShadow: '1px 2px 4px rgba(0, 0, 0, 0.3), 0 0 0 0.5px rgba(0, 0, 0, 0.1)',
      cursor: 'pointer',
      padding: 0,
      margin: 0,
      outline: 'none',
      transition: 'all 0.2s ease',
      overflow: 'hidden',
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = 'linear-gradient(135deg, #A855F7 0%, #8B3ED8 30%, #6B21A8 70%, #4C1D95 100%)';
      e.currentTarget.style.boxShadow = '1px 2px 6px rgba(0, 0, 0, 0.4)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = 'linear-gradient(135deg, #9945FF 0%, #7B2CBF 30%, #5A189A 70%, #3D0E61 100%)';
      e.currentTarget.style.boxShadow = '1px 2px 4px rgba(0, 0, 0, 0.3), 0 0 0 0.5px rgba(0, 0, 0, 0.1)';
    }}
  >
    {/* Top highlight */}
    <div style={{ position: 'absolute', top: '1px', left: '1px', right: '1px', height: '14px', borderRadius: '2px 2px 0 0', background: 'linear-gradient(to bottom, rgba(153, 69, 255, 0.7) 0%, rgba(123, 44, 191, 0.3) 40%, transparent 100%)', pointerEvents: 'none', zIndex: 1 }} />
    {/* Left highlight */}
    <div style={{ position: 'absolute', top: '1px', left: '1px', width: '14px', bottom: '1px', borderRadius: '2px 0 0 2px', background: 'linear-gradient(to right, rgba(153, 69, 255, 0.6) 0%, rgba(123, 44, 191, 0.2) 40%, transparent 100%)', pointerEvents: 'none', zIndex: 1 }} />
    {/* Bottom shadow */}
    <div style={{ position: 'absolute', bottom: '1px', left: '1px', right: '1px', height: '10px', borderRadius: '0 0 2px 2px', background: 'linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.1) 60%, rgba(0, 0, 0, 0.25) 100%)', pointerEvents: 'none', zIndex: 2 }} />
    {/* Right shadow */}
    <div style={{ position: 'absolute', top: '1px', right: '1px', width: '10px', bottom: '1px', borderRadius: '0 2px 2px 0', background: 'linear-gradient(to right, transparent 0%, rgba(0, 0, 0, 0.08) 60%, rgba(0, 0, 0, 0.2) 100%)', pointerEvents: 'none', zIndex: 2 }} />
    {/* Atomic number */}
    <span style={{ position: 'absolute', top: '2px', right: '3px', fontSize: '7px', fontWeight: 600, color: 'white', opacity: 0.95, zIndex: 15, pointerEvents: 'none', fontFamily: 'system-ui, -apple-system, sans-serif', lineHeight: 1 }}>
      {loading ? '...' : balance ? (balance >= 1 ? '16' : balance >= 0.1 ? '14' : '12') : '0'}
    </span>
    {/* Element symbol */}
    <span style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', marginTop: '-2px', fontSize: '18px', fontWeight: 700, color: 'white', zIndex: 15, pointerEvents: 'none', fontFamily: 'system-ui, -apple-system, sans-serif', lineHeight: 1, letterSpacing: '0' }}>
      Sol
    </span>
    {/* Balance text */}
    <span style={{ position: 'absolute', bottom: '7px', left: '50%', transform: 'translateX(-50%)', fontSize: '5.5px', fontWeight: 500, color: 'white', opacity: 0.9, zIndex: 15, pointerEvents: 'none', fontFamily: 'system-ui, -apple-system, sans-serif', textTransform: 'none', letterSpacing: '0', lineHeight: 1, whiteSpace: 'nowrap' }}>
      {loading ? '...' : balance ? `${balance.toFixed(2)}` : '0.00'}
    </span>
  </button>
);

export default WalletTile;
